(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  // Globo can close a preorder after Liquid renders; remove those cards locally.
  (() => {
    const initialize = () => {
      document.querySelectorAll('[data-ji-bl-recommendations]').forEach(section => {
        const removeClosed = () => {
          section.querySelectorAll('.product-card:not([data-ji-bl-closed])').forEach(card => {
            const controls = Array.from(card.querySelectorAll('button, [role="button"]'));
            if (controls.some(control => /pre[-\\s]?order\\s+closed/i.test(control.textContent || ''))) {
              card.dataset.jiBlClosed = 'true';
              card.hidden = true;
              card.style.display = 'none';
            }
          });
        };
        removeClosed();
        new MutationObserver(removeClosed).observe(section, {subtree: true, childList: true, characterData: true});
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
